import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    selectedCustomer: {},
    customers: [],
    loading: false,
    error: null,
    selectedCustomerType: "I"
}
export const getCustomers = createAsyncThunk(
    "customerSearch/getCustomers",
    async (customerSearchObj) => {
        const customerUrl = "/customer/getCustomer";
        try {
            const response = await wtyReportApi.post(customerUrl, customerSearchObj);
            if (response.status !== 200) {
                new Error("Calling api to get machines for customer failed.");
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    }
)

const customerSearchSlice = createSlice({
    name: "customerSearch",
    initialState,
    reducers: {
        setSelectedCustomer: (state, action) => {
            state.selectedCustomer = action.payload;
        },
        resetCustomersData: state => {
            state.customers = [];
            state.selectedCustomer = {};
        },
        resetCustomerList: state => {
            state.customers = [];
        },
        setCustCountryError: state => {
            state.error = "countryNotSelected";
        },
        setSelectedCustomerType: (state, action) => {
            state.selectedCustomerType = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getCustomers.pending, state => {
                state.loading = true;
                state.customers = [];
                state.error = undefined
            })
            .addCase(getCustomers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error;
            })
            .addCase(getCustomers.fulfilled, (state, action) => {
                state.loading = false;
                state.customers = action.payload;
                if (state.customers.length === 0) {
                    state.error = "customerNotFound";
                } else {
                    state.error = undefined;
                }
            })
    }
});

export const {
    setSelectedCustomer,
    resetCustomerList,
    resetCustomersData,
    setCustCountryError,
    setSelectedCustomerType,
    } = customerSearchSlice.actions;
export const customerList = (state) => state.customers.customers;
export const selectedCustomer = state => state.customers.selectedCustomer;
export const customerSearchError = state => state.customers.error;

export default customerSearchSlice.reducer;